import { useMemo, useState } from 'react';
import {
  discountItemTypeFilter,
  discountLifecycleStatus,
  discountStockFilter,
  DISCOUNT_LIST_PAGE_SIZE,
} from '../constants';
import { buildListQueryParams } from '../utils/discountHelpers';
import { AdvancedDiscountFilters } from '../components/AdvancedFiltersModal/AdvancedFiltersModal';

export function useDiscountFilters(pageSize = DISCOUNT_LIST_PAGE_SIZE) {
  const [stockFilter, setStockFilter] = useState<number>(discountStockFilter.All);
  const [statusFilter, setStatusFilter] = useState<number>(discountLifecycleStatus.All);
  const [itemTypeFilter, setItemTypeFilter] = useState<number>(discountItemTypeFilter.All);
  const [startDate, setStartDate] = useState('');
  const [endDate, setEndDate] = useState('');

  const advancedFilters: AdvancedDiscountFilters = useMemo(
    () => ({
      status: statusFilter,
      itemType: itemTypeFilter,
      startDate,
      endDate,
    }),
    [statusFilter, itemTypeFilter, startDate, endDate],
  );

  const setAdvancedFilters = (filters: AdvancedDiscountFilters) => {
    setStatusFilter(filters.status);
    setItemTypeFilter(filters.itemType);
    setStartDate(filters.startDate);
    setEndDate(filters.endDate);
  };

  const filters = useMemo(
    () =>
      buildListQueryParams({
        statusFilter,
        stockFilter,
        itemTypeFilter,
        pageNumber: 1,
        pageSize,
        startDate: startDate || undefined,
        endDate: endDate || undefined,
      }),
    [statusFilter, stockFilter, itemTypeFilter, startDate, endDate, pageSize],
  );

  return {
    stockFilter,
    statusFilter,
    itemTypeFilter,
    advancedFilters,
    filters,
    setStockFilter,
    setStatusFilter,
    setItemTypeFilter,
    setAdvancedFilters,
  };
}
